import { AppProvider } from "./contexts/app";
import { AuthProvider } from "./contexts/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Base from "./components/globals";
import { AuthenticatedRoute } from "./components/authenticated-route";

// pages...
import Home from "./app/dashboard/home/page";
import Inventory from "./app/dashboard/inventory/page";
import Login from "./app/dashboard/login/page";
import WeightDims from "./app/dashboard/weight-dims/page";
import OrderLabel from "./app/dashboard/order-label/page";
import OrderLabelPrint from "./app/dashboard/order-label/print";
import QC, { QCCompletedList } from "./app/dashboard/qc/page";
import QCPrint from "./app/dashboard/qc/print";
import FSHome from "./app/fs/home/page";
import FSQC from "./app/fs/qc/page";
import FSQC2 from "./app/fs/qc2/page";
import FSUnit from "./app/fs/unit/page";
import FSInventory from "./app/fs/inventory/page";
import Customer from "./app/fs/customer/page";
import Customers from "./app/fs/customers/page";
import CompletedUnits from "./app/fs/completed-units/page";
import SoakingUnits from "./app/fs/soaking/page";
import ShippingUnits from "./app/fs/shipping/page";
import Quote from "./app/fs/quotes/page";
import Quotes from "./app/fs/quotes/list";
import PDF from "./app/fs/quotes/pdf";
import FSInventory2 from "./app/fs/inventory2/page";
import QCPDI from "./app/fs/qc2/pdf";
import GoNoGo from "./app/fs/tracker/page1";
import GoNoGo2 from "./app/fs/tracker/page2";
import ProductionLineTracking from "./app/fs/tracker/page";
import MapBoard from "./app/fs/maps/page";
import GCloudImages from "./app/fs/gcloud-images/page";

function App() {
	return (
		<Router>
			<AuthProvider>
				<AppProvider>
					<Base>
						<Routes>
							<Route path="/dashboard/qc/:ID" element={<AuthenticatedRoute><QCPrint /></AuthenticatedRoute>} />
							<Route path="/dashboard/qc/print-all" element={<AuthenticatedRoute><QCPrint /></AuthenticatedRoute>} />
							<Route path="/dashboard/qc/completed" element={<AuthenticatedRoute><QCCompletedList /></AuthenticatedRoute>} />
							<Route path="/dashboard/qc/completed/serials" element={<AuthenticatedRoute><QCCompletedList serials /></AuthenticatedRoute>} />
							<Route path="/dashboard/qc" element={<AuthenticatedRoute><QC /></AuthenticatedRoute>} />

							<Route path="/dashboard/qc/edit" element={<AuthenticatedRoute><QC /></AuthenticatedRoute>} />
							<Route path="/dashboard/inventory" element={<AuthenticatedRoute><Inventory /></AuthenticatedRoute>} />
							<Route path="/dashboard/weight-dims" element={<AuthenticatedRoute><WeightDims /></AuthenticatedRoute>} />
							<Route path="/dashboard/order-labels" element={<AuthenticatedRoute><OrderLabel /></AuthenticatedRoute>} />
							<Route path="/dashboard/order-labels/print/:ID" element={<AuthenticatedRoute><OrderLabelPrint /></AuthenticatedRoute>} />
							<Route path="/" element={<AuthenticatedRoute><Home /></AuthenticatedRoute>} />
							<Route path="/login" element={<Login />} />
							<Route path="/fs" element={<AuthenticatedRoute><CompletedUnits /></AuthenticatedRoute>} />
							<Route path="/fs/unit" element={<AuthenticatedRoute><FSUnit /></AuthenticatedRoute>} />
							<Route path="/fs/unit/:id" element={<AuthenticatedRoute><FSUnit /></AuthenticatedRoute>} />
							<Route path="/fs/qc" element={<AuthenticatedRoute><FSQC /></AuthenticatedRoute>} />
							<Route path="/fs/qc/:id" element={<AuthenticatedRoute><FSQC /></AuthenticatedRoute>} />
							<Route path="/fs/units" element={<AuthenticatedRoute><FSInventory /></AuthenticatedRoute>} />
							<Route path="/fs/inventory" element={<AuthenticatedRoute><FSInventory /></AuthenticatedRoute>} />
							<Route path="/fs/customer" element={<AuthenticatedRoute><Customer /></AuthenticatedRoute>} />
							<Route path="/fs/customer/:id" element={<AuthenticatedRoute><Customer /></AuthenticatedRoute>} />
							<Route path="/fs/customers" element={<AuthenticatedRoute><Customers /></AuthenticatedRoute>} />
							<Route path="/fs/completed-units" element={<AuthenticatedRoute><CompletedUnits /></AuthenticatedRoute>} />
							<Route path="/fs/soaking" element={<AuthenticatedRoute><SoakingUnits /></AuthenticatedRoute>} />
							<Route path="/fs/shipping" element={<AuthenticatedRoute><ShippingUnits /></AuthenticatedRoute>} />
							<Route path="/fs/quote" element={<AuthenticatedRoute><Quote /></AuthenticatedRoute>} />
							<Route path="/fs/quotes" element={<AuthenticatedRoute><Quotes /></AuthenticatedRoute>} />
							<Route path="/fs/quote/:id" element={<AuthenticatedRoute><Quote /></AuthenticatedRoute>} />
							<Route path="/fs/quote/pdf" element={<AuthenticatedRoute><PDF /></AuthenticatedRoute>} />
							<Route path="/fs/quote/pdf/:id" element={<AuthenticatedRoute><PDF /></AuthenticatedRoute>} />

							<Route path="/fs/flock-inventory" element={<AuthenticatedRoute><FSInventory2 /></AuthenticatedRoute>} />
							<Route path="/fs/flock-inventory/:version" element={<AuthenticatedRoute><FSInventory2 /></AuthenticatedRoute>} />
							<Route path="/fs/flock-create" element={<AuthenticatedRoute><FSQC2 key="flock-create" /></AuthenticatedRoute>} />
							<Route path="/fs/flock-create/:version" element={<AuthenticatedRoute><FSQC2 key="flock-create-v" /></AuthenticatedRoute>} />
							<Route path="/fs/flock-edit/:id" element={<AuthenticatedRoute><FSQC2 key="flock-edit" /></AuthenticatedRoute>} />
							<Route path="/fs/flock-edit/:id/:version" element={<AuthenticatedRoute><FSQC2 key="flock-edit-v" /></AuthenticatedRoute>} />
							<Route path="/fs/flock/pdf/:id" element={<AuthenticatedRoute><QCPDI /></AuthenticatedRoute>} />
							<Route path="/fs/flock/pdf/:id/:version" element={<AuthenticatedRoute><QCPDI /></AuthenticatedRoute>} />

							<Route path="/fs/tracker" element={<AuthenticatedRoute><ProductionLineTracking /></AuthenticatedRoute>} />
							<Route path="/fs/tracker1" element={<AuthenticatedRoute><GoNoGo /></AuthenticatedRoute>} />
							<Route path="/fs/tracker2" element={<AuthenticatedRoute><GoNoGo2 /></AuthenticatedRoute>} />

							<Route path="/fs/map" element={<AuthenticatedRoute><MapBoard /></AuthenticatedRoute>} />

							<Route path="/fs/gcloud-images" element={<AuthenticatedRoute><GCloudImages /></AuthenticatedRoute>} />

						</Routes>
					</Base>
				</AppProvider>
			</AuthProvider>
		</Router>
	);
}

export default App;
